import { useTranslation } from 'react-i18next';

import { LanguagePicker } from '@workspace/shared/components/LanguagePicker';

import { setLanguage } from '~/hooks/useLang';
import { useMounted } from '~/hooks/useMounted';

import { getLanguageItems } from './getLanguageItems';

interface HeaderLanguageChipProps {
  className?: string;
}

/**
 * Header entry point for switching the interface language.
 *
 * Rendered only after mount, like the loyalty chip next to it: the server
 * resolves the language from `Accept-Language` while the client falls back to
 * the `lang` cookie or the company default, so language-derived markup in the
 * header diverges between the two renders on a first visit.
 */
const HeaderLanguageChip = ({ className }: HeaderLanguageChipProps) => {
  const { i18n, t } = useTranslation();
  const mounted = useMounted();

  if (!mounted) return null;

  return (
    <LanguagePicker
      items={getLanguageItems()}
      currentLang={i18n.language}
      onSelect={setLanguage}
      ariaLabel={t('chooseLanguage')}
      dataButton="mobile-header-change-language"
      className={className}
    />
  );
};

export default HeaderLanguageChip;
